module.exports = function() {
  return new Worker(__webpack_public_path__ + "95e49c57f880ea171aab.worker.js");
};